export default "<div  style='text-align: center'>\r\n    <p>Waiting for authorization…</p>   \r\n</div>"